const boxShadowForMenu = `0 1px 6px 0 rgba(69, 69, 69, 0.2),
0 1px 5px 0 rgba(69, 69, 69, 0.1)`;

export { boxShadowForMenu };
